import { render, staticRenderFns } from "./perfSetEdit.vue?vue&type=template&id=af86594a&scoped=true&"
import script from "./perfSetEdit.vue?vue&type=script&lang=js&"
export * from "./perfSetEdit.vue?vue&type=script&lang=js&"
import style0 from "./perfSetEdit.vue?vue&type=style&index=0&id=af86594a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af86594a",
  null
  
)

component.options.__file = "perfSetEdit.vue"
export default component.exports